import {
  paramOrNul, getClientPlatform, getData, calculateDifference, getDateFromServerUTC
} from '../../../common/config/utils';
import enviroment from '../enviroment';
import { getCurrentLocalization } from '../localization';

const {
  BACKEND_VERSION
} = enviroment;

export const generateUserProperties = () => {
  const date = getDateFromServerUTC();
  const { user:{ user } } = window.store.getState();
  let baseProperties = {
    day: getData({ date, type: 'date' }),
    'day of week': getData({ date, type: 'day' }),
    'hour of day': getData({ date, type: 'hours' }),
    year: getData({ date, type: 'year' }),
    month: getData({ date, type: 'month' }),
    'year-month': `${ getData({ date, type: 'year' }) }-${ getData({ date, type: 'month' }) }`,
    language: getCurrentLocalization(),
    platform: getClientPlatform()
  };
  if (user) {
    baseProperties = {
      ...baseProperties,
      'user id': user.userId,
      'user type': 'client',
      'credit balance': parseFloat(user.clientAvailableCredit),
      'total purchased': parseFloat(user.totalPurchased),
      'total purchase fees paid': parseFloat(user.totalPurchaseFeesPaid),
      'purchases count': user.purchasesCount,
      ...paramOrNul('last purchase date', user.lastPurchaseDate),
      'days since last purchase': calculateDifference({ date1: date, date2: user.lastPurchaseDate, type: 'days' }) || 0,
      ...paramOrNul('email address', user.email),
      ...paramOrNul('login type', user.loginType),
      ...paramOrNul('gender', user.gender),
      ...paramOrNul('age', calculateDifference({ date1: date, date2: user.dateOfBirth, type: 'years' })),
      ...paramOrNul('install date', user.installDate),
      'days from install': calculateDifference({ date1: date, date2: user.installDate, type: 'days' }) || 0,
      ...paramOrNul('signup date', user.createdAt),
      'days from signup': calculateDifference({ date1: date, date2: user.createdAt, type: 'days' }) || 0,
      'backend version': parseInt(BACKEND_VERSION, 10),
      ...paramOrNul('paypal total charged', user.paypalTotalCharged),
      ...paramOrNul('credit card total charged', user.creditCardTotalCharged),
      'order count': user.numberOfOrders
    };
  }
  return baseProperties;
};
